module.exports = __webpack_public_path__ + "img/Laos.c9ed6964.svg";